import { render, staticRenderFns } from "./UnsubscribeResultComponent.vue?vue&type=template&id=4246b130&scoped=true&"
import script from "./UnsubscribeResultComponent.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeResultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246b130",
  null
  
)

export default component.exports